// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__exj4H","large":"styles_large__3NkS8"};